// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"n2rTQ","rc-tabs-tab":"+rqHc","rc-tabs-tab-active":"IFT0b","tip":"pBrrr","tip-label":"_24hld","tip-group":"_5RZ5T"};